// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"ce04727a","236":"8797ceb1","408":"d1f1d40b","453":"ba19ab7d","514":"beabc33d","563":"fbcd9b6a","910":"a590fb9d","934":"d9c3f774"}[chunkId] + ".chunk.js";
};